import React, { FC, useMemo } from 'react';

import { ReactComponent as ChevronLeftIcon } from '../../../icons/chevronLeft.svg';
import { ReactComponent as ArrowLeftIcon } from '../../../icons/arrowLeft.svg';
import Link, { LinkProps } from '../Link';
import InternalLink, { InternalLinkProps } from '../InternalLink';

import { StyledIcon } from './BackLink.styles';

export interface BackLinkProps extends LinkProps, InternalLinkProps {
  /** Use the large arrow variant. */
  largerArrow?: boolean;
}

const BackLink: FC<BackLinkProps> = ({ largerArrow, ...props }) => {
  const LinkType = useMemo(() => props.to ? InternalLink : Link, [props.to]);
  const Icon = useMemo(() => largerArrow ? () => <StyledIcon as={ArrowLeftIcon} /> : ChevronLeftIcon, [largerArrow]);
  return (
    <LinkType LeftIcon={Icon} {...props} />
  );
};

export default BackLink;
